import styled from 'styled-components';

export const LandingInformation = styled.div`
  @media (max-width: 767px) {
    .dp-landing-information-column {
      flex-basis: 100%;
      max-width: 100%;
    }
  }
`;
